import { getGroupCashLocations, getGroupFreeDevices } from "@/api/gql/device";
import { IDeviceState } from "@/interfaces/store/IDevice";
import { CashLocation, DeviceInfo } from "@/types/gql/device";
import {
  getModule,
  VuexModule,
  Mutation,
  Action,
  Module,
} from "vuex-module-decorators";
import store from "..";
import POSConfigModule from "./pos-config";
// import { IFiskalyState } from "@/interfaces/store/IFiskalyState";
// import { ICounter } from "@/types/db/transaction";
// import { formatCounter } from '@smeetz/counter-formatter';
// import { getReceiptCounter, postReceiptCounter } from "@/api/receipt-counter/receipt-counter";
// import { LogService } from "@/services/logging";

@Module({ dynamic: true, namespaced: true, store, name: "Device" })
class DeviceStoreModule extends VuexModule implements IDeviceState {
  public model = "";
  public modelId = "";
  public ram = "";
  public id = "";
  public brand = "";
  public manufacturer = "";
  public osVersion = "";
  public osName = "";
  public deviceInfo: DeviceInfo | null = null;
  public hardwareInfo: any | null = null;
  public devices: DeviceInfo[] = [];
  public locations: CashLocation[] = [];
  public hardwareLocation: {
    locationName?: string;
    locationId: number;
    deviceName: string;
    deviceId: number;
    deviceUid: string;
    FiskalyCashRegisterId: string;
  } | null = null;

  // // holds all data related to counter logic
  // // It represents only the current counter, which is attached to the last order sessio completion
  // public receiptCounter: ICounter | null = null;

  /**
   * This getter is done for few organizers so that they can use deviceId+cpuId as a hardwareUuuid
   * The rest are the ones that we might have set manualHardwareUuid in their devices localStorage
   * which we will need to migrate their manualHardwareUuid into a deviceId+cpuId
   */
  public get canHaveManualHardwareUuid() {
    if (
      POSConfigModule.groupId &&
      [
        /*1, 19066, 16342 /*TEST*/ /*, 16383 /*DEV*/ 19319, 19543, 19544, 19545,
        19546 /*FlipLab groups*/, 19547 /*Fort boyard*/, 19682,
      ].includes(POSConfigModule.groupId)
    )
      return true;
    return false;
  }

  /**
   * Returns adyen saleid which is the pos identifier
   */
  get adyenSaleId(): string {
    return `${POSConfigModule.groupId}-${this.deviceUid}`;
  }

  get cashRegisterId(): string {
    // return deviceId if there is a location linked to this hardware
    // otherwise we return deviceUid from old device settings selected by user
    if (this.hardwareLocation && this.hardwareLocation.deviceUid) {
      return String(this.hardwareLocation.deviceUid);
    }
    return DeviceModule.deviceUid;
  }

  get newLogicDeviceId(): number {
    // return deviceId if there is a location linked to this hardware
    // otherwise we return deviceUid from old device settings selected by user
    if (this.hardwareLocation && this.hardwareLocation.deviceId) {
      return this.hardwareLocation.deviceId;
    }
    return this.deviceInfo?.id || 0;
  }

  get deviceId(): number {
    return this.deviceInfo?.id || 0;
  }

  get getDevices() {
    return this.devices;
  }

  get deviceUid(): string {
    return this.deviceInfo?.deviceUid || "";
  }

  get getHardwareHash(): string {
    return this.hardwareInfo?.hardwareHashDetails?.hash || "";
  }

  get getHardwareHashV2(): string {
    return this.hardwareInfo?.hardwareHashDetails?.hashV2 || "";
  }

  @Mutation
  public setDeviceInfo(deviceInfo: DeviceInfo) {
    this.deviceInfo = deviceInfo;
  }

  @Mutation
  public setHardwareInfo(hardwareInfo: any) {
    this.hardwareInfo = hardwareInfo;
  }

  @Mutation
  public setHardwareLocation(
    location: {
      locationId: number;
      deviceName: string;
      deviceId: number;
      deviceUid: string;
      FiskalyCashRegisterId: string;
      locationName?: string;
    } | null
  ) {
    this.hardwareLocation = location;
  }

  @Mutation
  public setDevices(devices: DeviceInfo[]) {
    this.devices = devices;
  }

  @Mutation
  public restore(moduleFields: IDeviceState) {
    const { deviceInfo, hardwareInfo, locations, hardwareLocation, devices } =
      moduleFields;
    if (deviceInfo) {
      this.deviceInfo = deviceInfo;
    }
    if (hardwareInfo) {
      this.hardwareInfo = hardwareInfo;
    }
    if (hardwareLocation) {
      this.hardwareLocation = hardwareLocation;
    }
    if (locations) {
      this.locations = locations;
    }
    if (this.devices) {
      this.devices = devices;
    }
    // if (receiptCounter) {
    //   this.receiptCounter = receiptCounter;
    // }
  }
  @Mutation
  public setLocations(locations: CashLocation[]) {
    this.locations = locations;
  }

  @Action
  public async fetchDevices() {
    if (!POSConfigModule.groupId) {
      throw new Error("Group id is not set for fetching devices");
    }

    const devices = await getGroupFreeDevices(POSConfigModule.groupId);
    this.setDevices(devices);
    return devices;
  }

  @Action
  public async fetchLocations() {
    if (!POSConfigModule.groupId) {
      throw new Error("Group id is not set for fetching locations");
    }

    const locations = await getGroupCashLocations(POSConfigModule.groupId);
    this.setLocations(locations);
    return locations;
  }

  // @Action
  // public async fetchReceiptCounter(deviceUid: string): Promise<ICounter> {
  //   console.log("----------- hi from fetchReceiptCounter");
  //   const groupId = String(POSConfigModule.groupInfo?.id);
  //   const reference = "P" + String(this.deviceInfo?.deviceUid).substring(0, 3);
  //   try {
  //     const receiptCounter: ICounter = await getReceiptCounter({ groupId: groupId, reference: reference });
  //     console.log("-------- receiptCounter");
  //     console.log(receiptCounter);
  //     return receiptCounter;

  //   } catch (err:any) {
  //     console.log(err);
  //     LogService.info(`Receipt Counter: error when trying to GET receipt counter for groupId: ${groupId} and reference: ${reference}`, {
  //       err,
  //     });
  //     // Check for 404 error
  //     if (err.response && err.response.status === 404) {
  //       // Call postReceiptCounter if 404
  //       // This will trigger backed to create the first counter for this device
  //       try {
  //         const initiatedReceiptCounter = await postReceiptCounter({ groupId, reference });
  //         // Lets return the hard coded counter for now
  //         return initiatedReceiptCounter;
  //       } catch (error) {
  //         console.log(err);
  //         LogService.info(`Receipt Counter: error when trying to POST receipt counter for groupId: ${groupId} and reference: ${reference} to trigger the first counter creation`, {
  //           err,
  //         });
  //         throw new Error("Receipt Counter: could not get receipt counter, nor initialize it");
  //       }
  //     } else {
  //       throw new Error("Receipt Counter: could not GET receipt counter");
  //     }
  //   }
  // }
}

const DeviceModule = getModule(DeviceStoreModule);
export default DeviceModule;
